var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('hyper-backup',{ref:"hBack",on:{"selectVersion":_vm.onSelectVersion,"showDiff":_vm.onShowDiff,"newFilter":_vm.onNewFilter}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }